import React from 'react'
// This is the index page banner
const BannerHome = (props) => (
    <section id="banner" className="major index-banner2">
        <div className="inner">
            <header className="major">
                <h1>Let me introduce myself</h1>
            </header>
            <div className="content">
                <p>My name is Mike Hancock and I’ve been born and bred in Portsmouth. 
                As a journalist, I’ve dedicated my career over the last 20 odd years to following the latest news and exploits of the local MPs and party representatives</p>
                <ul className="actions">
                    <li><a href="/about" className="button next">About Me</a></li>
                </ul>
            </div>
        </div>
    </section>
)

export default BannerHome



// WEBPACK FOOTER //
// ./src/components/BannerHome.js